import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '@/context/LanguageContext';
import { useAuth } from '@/context/AuthContext';
import { Users, User, Heart, Sparkles, Cross } from 'lucide-react';
import BuddhaIcon from '@/components/icons/BuddhaIcon';
import { motion } from 'framer-motion';

export default function BottomNav({ active }) {
  const navigate = useNavigate();
  const { lang } = useLang();
  const { claimedProfile } = useAuth();

  const isBuddhist = claimedProfile?.category === 'Buddhist Match';
  const isKatolik = claimedProfile?.category === 'Katholik Match';

  const items = [
    { key: 'browse', icon: Users, path: '/browse' },
    { key: 'ai-match', icon: Sparkles, path: '/ai-match' },
    { key: 'liked', icon: Heart, path: '/liked' },
    ...(isBuddhist ? [{ key: 'buddhist', icon: BuddhaIcon, path: '/buddhist' }] : []),
    ...(isKatolik ? [{ key: 'katolik', icon: Cross, path: '/katolik' }] : []),
    { key: 'profile', icon: User, path: '/profile' },
  ];

  const labels = {
    browse: lang === 'en' ? 'Browse' : 'Jelajahi',
    'ai-match': lang === 'en' ? 'AI Match' : 'AI Match',
    liked: lang === 'en' ? 'Liked' : 'Disukai',
    buddhist: lang === 'en' ? 'Buddhist' : 'Buddhist',
    katolik: lang === 'en' ? 'Katolik' : 'Katolik',
    profile: lang === 'en' ? 'Profile' : 'Profil',
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 pb-4">
      <nav className="glass rounded-2xl mx-auto max-w-md" data-testid="bottom-nav">
        <div className="flex items-center justify-around py-3">
          {items.map(item => {
            const isActive = active === item.key;
            return (
              <button
                key={item.key}
                onClick={() => navigate(item.path)}
                data-testid={`nav-${item.key}`}
                className="relative flex flex-col items-center gap-1 px-4 py-1 transition-all"
              >
                <div className="relative">
                  <item.icon className={`w-5 h-5 transition-colors ${isActive ? 'text-[#D98A94]' : 't-text-muted'}`} fill={isActive && item.key === 'liked' ? '#D98A94' : 'none'} />
                  {isActive && (
                    <motion.div layoutId="nav-indicator" className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[#D98A94]" />
                  )}
                </div>
                <span className={`text-[10px] transition-colors ${isActive ? 'text-[#D98A94]' : 't-text-muted'}`}>
                  {labels[item.key] || item.key}
                </span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
